"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueue = void 0;
class EventQueue {
    constructor() {
        this.queue = [];
        this.isProcessing = false;
        this.observers = [];
    }
    subscribe(observer) {
        this.observers.push(observer);
    }
    enqueue(event) {
        this.queue.push(event);
        // If nothing is actively processing, kick off the queue processing
        if (!this.isProcessing) {
            // TODO: shouldn't this check be inside the function?
            const _ = this.processQueue();
        }
    }
    processQueue() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isProcessing = true;
            while (this.queue.length > 0) {
                const nextEvent = this.queue.shift();
                if (nextEvent === undefined) {
                    // Safeguard
                    continue;
                }
                yield this.notifyObservers(nextEvent);
            }
            this.isProcessing = false;
        });
    }
    notifyObservers(event) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const observer of this.observers) {
                yield observer(event);
            }
        });
    }
}
exports.EventQueue = EventQueue;
